import {Grid, WithStyles, withStyles} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import {Trans} from 'react-i18next'

import messages from '../../../../../../../../assets/messages'
import {getFormattedAmount} from '../../../../../../../../common/utils'
import {Currency} from '../../../../../../../../graphql/types'
import {styles} from '../styles'

type DepositNeededBadgeProps = WithStyles<typeof styles> & {
  minimumDeposit: number
  currency: Currency | null
}

const _DepositNeededBadge = (props: DepositNeededBadgeProps) => {
  const {classes, minimumDeposit, currency} = props

  return (
    <Grid item className={classNames(classes.pending, classes.isDemoArchived)}>
      <Typography variant='caption' className={classes.pendingText}>
        <Trans
          {...messages.depositNeeded}
          values={{amount: getFormattedAmount({currency, amount: minimumDeposit})}}
        />
      </Typography>
    </Grid>
  )
}

export const DepositNeededBadge = withStyles(styles, {withTheme: true})(_DepositNeededBadge)
